import { css } from 'styled-components';
import BREAKPOINTS from '@mlb/react-patterns/style/breakpoints.ts';

export const wrapperClass = 'vpp-main-container';

export const cqClassPrepend = 'main-cq--';

export const mainCq = Object.keys(BREAKPOINTS).reduce((acc, label) => {

    acc[`${label}`] = (...args) => css`

        .${wrapperClass}:not([class*=" ${cqClassPrepend}"]) && {
            @media screen and (min-width: ${BREAKPOINTS[label]}) {
                ${css.call(this, ...args)};
            }
        }

        .${cqClassPrepend}${label.toUpperCase()} && {
            ${css.call(this, ...args)};
        }
    `;

    return acc;

}, {});
